"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Span = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: ", ""])), function (props) {
  var _props$background;
  return props.withBackground && props.checked ? (_props$background = props.background) !== null && _props$background !== void 0 ? _props$background : props.theme.primaryColor : props.withBackground ? '#f2f2f2' : undefined;
});
var Checkbox = function Checkbox(_ref) {
  var background = _ref.background,
    className = _ref.className,
    checked = _ref.checked,
    disabled = _ref.disabled,
    label = _ref.label,
    labelTextClassName = _ref.labelTextClassName,
    _ref$withBackground = _ref.withBackground,
    withBackground = _ref$withBackground === void 0 ? false : _ref$withBackground,
    errorMsg = _ref.errorMsg,
    hasError = _ref.hasError,
    _onChange = _ref.onChange,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    onClick = _ref.onClick;
  var labelClasses = (0, _classnames3.default)(_styles.default.item, className, _defineProperty(_defineProperty({}, _styles.default.hasError, hasError), _styles.default.disabled, disabled));
  return /*#__PURE__*/_react.default.createElement("label", {
    className: labelClasses,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/_react.default.createElement("input", {
    checked: checked,
    className: _styles.default.checkbox,
    disabled: disabled,
    type: "checkbox",
    onChange: function onChange(e) {
      return _onChange(e.target.checked, e);
    }
  }), /*#__PURE__*/_react.default.createElement(Span, {
    background: background,
    checked: checked,
    className: (0, _classnames3.default)(_styles.default.name, labelTextClassName, _defineProperty(_defineProperty(_defineProperty({}, _styles.default.styledLabel, withBackground), _styles.default.noLabel, !label), _styles.default['styledLabel--color-white'], withBackground && checked)),
    withBackground: withBackground
  }, label), errorMsg && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.error
  }, errorMsg));
};
Checkbox.propTypes = {
  background: _propTypes.default.string,
  className: _propTypes.default.string,
  checked: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool,
  label: _propTypes.default.node,
  labelTextClassName: _propTypes.default.string,
  errorMsg: _propTypes.default.string,
  hasError: _propTypes.default.bool,
  withBackground: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  onClick: _propTypes.default.func
};
var _default = exports.default = Checkbox;